import React, { useEffect, useState } from "react";
import Footer from "@/components/footer";
import Layout from "@/components/layout";
import PageBanner from "@/components/page-banner";
import AboutOne from "@/components/about-one";
import CallToActionOne from "@/components/call-to-action-one";
import TeamCarousel from "@/components/team-carousel";
import VideoOne from "@/components/video-one";
import SubscribeForm from "@/components/subscribe-form";
import TestimonialsOneCarousel from "@/components/testimonials-carousel";
import FeatureTabOne from "@/components/feature-tab-1";
import HeaderOne from "@/components/header-one";
import SearchContextProvider from "@/context/search-context";
import MenuContextProvider from "@/context/menu-context";
import ServiceDetails from "@/components/service-details";
import SEO from "../components/seo";
import { Col, Container, Row } from "react-bootstrap";
import serviceS1 from "@/images/s1.jpg";
import serviceS2 from "@/images/s2.jpg";
import ContactForm from "@/components/contact-form";
import SectionTitle from "@/components/section-title";
import PortfolioCard from "@/components/portfolio-card";
const AboutUsPage = () => {
  const [images, setImages] = useState([]);
  useEffect(() => {
    const loadImages = async () => {
      let imageArray = [];

      for (let i = 0; i <= 27; i++) {
        const image = await import(`@/images/gallery/indoor/indoor${i}.webp`);
        console.log("the images", image);
        imageArray.push(image.default);
      }
      setImages([...imageArray]);
    };

    loadImages();
  }, []);
  return (
    <MenuContextProvider>
      <SearchContextProvider>
        <Layout PageTitle="Cleanup Service">
          <SEO title="Cleanup Service" />
          <HeaderOne />
          {/* <PageBanner
            title="Indoor Plants"
            name="Indoor Plants"
            subtitle="ell"
          /> */}
          <section className="pageBanner">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="banner_content text-center">
                    <h4>
                      <a href="/">home</a> / <a href="/service">Services</a> /
                      Cleanup Serivces
                    </h4>
                    <h2>Cleanup Services</h2>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* <ServiceDetails /> */}
          <section className="commonSection service_detail">
            <Container>
              <div className="serviceArea">
                {/* <img src={serviceS1} alt="" /> */}
                <h2>Cleanup Serivces</h2>
                <p style={{ fontSize: "140%" }}>
                  Fertile Garden Center offers a comprehensive Cleanup Service
                  designed to keep your garden in pristine condition year-round.
                  Our expert team handles everything from removing leaves and
                  debris to trimming overgrown plants and shrubs, ensuring a
                  clean and attractive landscape. We cater to both residential
                  and commercial properties, providing tailored solutions to
                  meet your specific needs. With our reliable and efficient
                  service, you can enjoy a well-maintained garden without the
                  hassle. Trust Fertile Garden Center to bring out the best in
                  your outdoor spaces.
                  {/* <br></br>
                  <br></br>
                  We understand that indoor plants not only enhance the
                  aesthetic appeal of your space but also contribute to a
                  healthier environment by improving air quality and reducing
                  stress levels. Our knowledgeable staff is always available to
                  help you choose the perfect plants for your specific needs and
                  preferences. Whether you're a seasoned plant enthusiast or a
                  beginner looking to start your indoor garden, we have the
                  right plants and advice to get you started.
                  <br></br>
                  <br></br>
                  At Fertile Garden Center, we believe in the importance of
                  quality and customer satisfaction. We provide detailed care
                  instructions for all our plants to ensure they continue to
                  flourish in your care. Visit us today and explore our
                  beautiful range of indoor plants, and let us help you create a
                  greener, more serene living or working space. */}
                </p>
                {/* <div className="row gaping">
                  <div className="col-lg-6 col-sm-12 col-md-6">
                    <img src={serviceS2} alt="" />
                  </div>
                  <div className="col-lg-6 col-sm-12 col-md-6">
                    <h3>planning & strategy</h3>
                    <p>
                      At Fertile Garden Center, we take pride in offering a wide
                      variety of high-quality indoor plants that can transform
                      any indoor space into a lush, green oasis. Our selection
                      includes everything from low-maintenance succulents and
                      air plants to vibrant flowering varieties and large
                      statement plants. Each plant is carefully selected to
                      ensure it is healthy and ready to thrive in your home or
                      office. We understand that indoor plants not only enhance
                      the aesthetic appeal of your space but also contribute to
                      a healthier environment by improving air quality and
                      reducing stress levels. Our knowledgeable staff is always
                      available to help you choose the perfect plants for your
                      specific needs and preferences. Whether you're a seasoned
                      plant enthusiast or a beginner looking to start your
                      indoor garden, we have the right plants and advice to get
                      you started. At Fertile Garden Center, we believe in the
                      importance of quality and customer satisfaction. We
                      provide detailed care instructions for all our plants to
                      ensure they continue to flourish in your care. Visit us
                      today and explore our beautiful range of indoor plants,
                      and let us help you create a greener, more serene living
                      or working space.
                    </p>
                    <ul>
                      <li>
                        <i className="fa fa-check-square"></i>Research beyond
                        the business plan
                      </li>
                      <li>
                        <i className="fa fa-check-square"></i>Marketing options
                        and rates
                      </li>
                      <li>
                        <i className="fa fa-check-square"></i>The ability to
                        turnaround consulting
                      </li>
                      <li>
                        <i className="fa fa-check-square"></i>Help companies
                        into more profitable
                      </li>
                      <li>
                        <i className="fa fa-check-square"></i>Customer
                        engagement matters
                      </li>
                    </ul>
                  </div>
                </div>
                <p>
                  Need something changed or is there something not quite working
                  the way you envisaged? Is your van a little old and tired and
                  need refreshing? Lorem Ipsum is simply dummy text of the
                  printing and typesetting industry. Lorem Ipsum has been the
                  industry's standard dummy text ever since the 1500s, when an
                  unknown printer took a galley of type and scrambled it to make
                  a type specimen book. It has survived not only five centuries,
                  but also the leap into electronic typesetting, remaining
                  essentially unchanged.
                </p>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen book. It has survived not only five centuries, but
                  also the leap into electronic typesetting, remaining
                  essentially unchanged.
                </p> */}
              </div>
              {/* <Row>
          <Col lg={8} md={12}>
            <ServiceDetailsContent />
          </Col>
          <Col lg={4} md={12} className="sidebar">
            <ServiceSidebar />
          </Col>
        </Row> */}
            </Container>
          </section>

          <ContactForm style={{ padding: 0 }} />
          {/* <AboutOne />
          <TestimonialsOneCarousel />
          <SubscribeForm />
          <TeamCarousel />
          <VideoOne />
          <FeatureTabOne />
          <CallToActionOne extraClassName="ready" /> */}
          <Footer />
        </Layout>
      </SearchContextProvider>
    </MenuContextProvider>
  );
};

export default AboutUsPage;
